import { render } from "./the-sidebar.vue?vue&type=template&id=968f8e82&scoped=true"
import script from "./the-sidebar.vue?vue&type=script&lang=js"
export * from "./the-sidebar.vue?vue&type=script&lang=js"

import "./the-sidebar.vue?vue&type=style&index=0&id=968f8e82&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-968f8e82"]])

export default __exports__